import { Injectable, signal } from "@angular/core";
import { emptyTask, TaskModel, TaskPriority, TaskStatus } from "../03_model/task.model";
import { of } from "rxjs";

export type TaskQueryMode = 'own' | 'team' | 'substitute';

@Injectable({ providedIn: 'root' })
export class TaskService {

  id = 0;
  openTasks = signal(new Array(3).fill(0).map(() => <TaskModel>{ ...emptyTask(), id: '' + this.id++ }));
  progressTasks = signal(new Array(2).fill(0).map(() => <TaskModel>{ ...emptyTask(), id: '' + this.id++ }));
  reviewTasks = signal(new Array(1).fill(0).map(() => <TaskModel>{ ...emptyTask(), id: '' + this.id++ }));
  doneTasks = signal(new Array(50).fill(0).map(() => <TaskModel>{ ...emptyTask(), id: '' + this.id++ }));

  getTasks(queryMode: TaskQueryMode, status: TaskStatus, lastKey: any) {
    if (!lastKey) {
      switch (status) {
        case TaskStatus.open: return of({ data: this.openTasks(), lastKey: null });
        case TaskStatus.inProgress: return of({ data: this.progressTasks(), lastKey: null });
        case TaskStatus.inReview: return of({ data: this.reviewTasks(), lastKey: null });
        case TaskStatus.done: return of({ data: this.doneTasks(), lastKey: null });
      }
    }
    return of({ data: [], lastKey: null });
  }

  getTaskCount(queryMode: TaskQueryMode, status: TaskStatus) {
    switch (status) {
      case TaskStatus.open: return of({ count: this.openTasks().length });
      case TaskStatus.inProgress: return of({ count: this.progressTasks().length });
      case TaskStatus.inReview: return of({ count: this.reviewTasks().length });
      case TaskStatus.done: return of({ count: this.doneTasks().length });
    }
  }

  async createTask(partialTask: Partial<TaskModel>) {
    const newTask: TaskModel = {
      id: '' + this.id++,
      name: partialTask.name || 'New Task',
      dueDate: partialTask.dueDate || new Date(),
      priority: partialTask.priority || TaskPriority.mid,
      summary: partialTask.summary || '',
      status: TaskStatus.open
    };
    this.openTasks.set([...this.openTasks(), newTask]);
    return newTask;
  }
}
